<template>
    <div>
        Hello World
    </div>
</template>
<script>
export default {
  name: "testing",
  components: {}
};
</script>
<style>
</style>
